import { useEffect, useState } from 'react';

/**
 * Custom hook to dynamically return Ant Design Table scroll configuration
 * based on window innerWidth.
 *
 * @param minWidth - Screen width threshold (default: 1024px)
 * @returns {{ x: number } | undefined} Ant Design Table scroll prop object or undefined
 */
export const useTableScroll = (minWidth: number = 1024) => {
  const [scroll, setScroll] = useState<{ x: string } | undefined>(() =>
    typeof window !== 'undefined' && window.innerWidth <= minWidth
      ? { x: 'max-content' }
      : undefined
  );

  useEffect(() => {
    const handleResize = () => {
      setScroll(
        window.innerWidth <= minWidth ? { x: 'max-content' } : undefined
      );
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [minWidth]);

  return scroll;
};

export default useTableScroll;
